import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Calendar, LucideAngularModule } from 'lucide-angular';
import { DateFormattingService } from '../../../core/services/date-formatting.service';
import { InfoLineComponent } from '../info-line/info-line.component';

@Component({
  selector: 'app-datetime-info-line',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, InfoLineComponent],
  templateUrl: './datetime-info-line.component.html',
})
export class DatetimeInfoLineComponent {
  startDate = input.required<Date>();
  endDate = input.required<Date>();
  additionalClasses = input<string>();

  private dateFormattingService = inject(DateFormattingService);

  protected readonly icon = Calendar;
  protected readonly text = computed(() => {
    return this.dateFormattingService.formatEventDateCompact(new Date(this.startDate()), new Date(this.endDate()));
  });
}
